import { render } from "./Unit4-4.vue?vue&type=template&id=37b16fe7&scoped=true"
import script from "./Unit4-4.vue?vue&type=script&lang=js"
export * from "./Unit4-4.vue?vue&type=script&lang=js"

import "../assets/css/common.css?vue&type=style&index=0&lang=css"
import "../assets/css/Unit4-4.css?vue&type=style&index=1&id=37b16fe7&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b16fe7"]])

export default __exports__